import { ConferenceScheduleItem } from 'types/models/Conference';
import getUniqueValues from 'utils/getUniqueValues';
import map from 'utils/map';

export const transformSchedules = (items: ConferenceScheduleItem[]) => {
  const days: string[] = map(getUniqueValues(items, 'date'), 'date');
  const additionalInfo: string[] = [];
  const schedules = days.map((day) => ({
    day,
    items: items
      .filter(({ date }) => date === day)
      .map(({ title, additionalInfo: additionalInfoText, ...scheduleItem }) => {
        if (additionalInfoText) {
          additionalInfo.push(`${'*'.repeat(additionalInfo.length + 1)}${additionalInfoText}`);

          return { ...scheduleItem, title: `${title}${'*'.repeat(additionalInfo.length)}` };
        }

        return { ...scheduleItem, title };
      }),
  }));

  return { schedules, additionalInfo };
};
